import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import IconPostmag from "./icon-postmag.svg";
import IconStyle from "./icon-style.svg";

export const ItemContainer = styled.div``;

export const StyledIconPostmag = styled(IconPostmag)`
  inline-size: 74px;
  block-size: 18px;
  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 99px;
    block-size: 24px;
  }
`;

export const StyledIconStyle = styled(IconStyle)`
  inline-size: 36px;
  block-size: 24px;
  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 48px;
    block-size: 32px;
  }
`;
